import cn from 'classnames';
import React, {FC, useState} from 'react';
import {Dispatch} from 'redux';

import {CancelIcon, ErrorIcon, IconSuccess, WarningIcon} from '../../../components/Icons';
import * as notificationTypes from '../../../consts/app/notificationTypes';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import NotificationModalTypes from '../../../enums/app/notificationModalTypes';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {removeNotification} from '../../../state/ducks/global';
import arrayUtils from '../../../utils/arrayUtils';
import ReconnectNotification from './components/ReconnectNotification/ReconnectNotification';
import {INotification} from './NotificationTypes';

interface IProps {
    dispatch: Dispatch<any>;
    notification: INotification;
    key: number;
}

const Notification: FC<IProps> = (props) => {
    const {dispatch, notification} = props;
    const {notificationId, textKey, textFormatValues, type, testId, notificationType, autoFocus} = notification;
    const [isActive, setIsActive] = useState(false);
    const localizedStrings = getLocalizedStrings();
    const Icon = getIcon(type);

    const onNotificationClick = () => {
        if (!isActive) {
            setIsActive(true);

            hideNotification();
        }
    };

    const hideNotification = () => {
        dispatch(removeNotification(notificationId));
    };

    let customNotification;

    switch (notificationType) {
        case NotificationModalTypes.RECONNECT_DEVICE:
            customNotification = (
                <ReconnectNotification onClick={onNotificationClick} hideNotification={hideNotification} />
            );
            break;
    }

    return (
        <div
            className={cn(
                `relative flex w-full items-center gap-4 rounded bg-secondary py-4 pl-6 pr-11 
                 lg:gap-6 lg:py-7 lg:pl-6 lg:pr-10`,
                {
                    'animate-hide': isActive,
                }
            )}
            data-testid={testId}
        >
            <Icon className='h-6 w-6 flex-shrink-0' />
            <p className='body-14 flex-1 text-start' role={autoFocus ? '' : 'status'}>
                {customNotification ? (
                    customNotification
                ) : (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: getText(textKey!, textFormatValues),
                        }}
                    />
                )}
            </p>
            <button
                aria-label={localizedStrings[localizationKeys.CLOSE_NOTIFICATION_ARIA_LABEL]}
                className='absolute top-0 p-2 ltr:right-0 rtl:left-0'
                onClick={onNotificationClick}
            >
                <CancelIcon className='h-5 w-5' />
            </button>
        </div>
    );
};

export default Notification;

const getText = (textKey: string, textFormatValues?: string | string[]) => {
    const formatValues = arrayUtils.toArray(textFormatValues);
    const localizedStrings = getLocalizedStrings();

    return localizedStrings.formatString(localizedStrings[textKey], ...formatValues);
};

const getIcon = (type: string): FC<any> => {
    switch (type) {
        case notificationTypes.FAILED:
            return ErrorIcon;

        case notificationTypes.SUCCESS:
            return IconSuccess;

        case notificationTypes.INFO:
            return WarningIcon;
    }

    return WarningIcon;
};
